import { Map } from 'immutable';
import actions from './actions';

const initState = new Map({
  idToken: null, firstTimeLogin: false, groups: [], providerId: null, dbId: null, s3Photo: null,
  therapist: null, clients:null, timezone:null, teamMembers:null, insuranceSettings:null,
  practiceDetails:null, billingSettings:null
});

export default function authReducer(state = initState, action) {
  switch (action.type) {
    case actions.LOGIN_SUCCESS:
      return state.set('idToken', action.token);
    case actions.LOGOUT:
      return initState;
    case actions.IS_FIRST_TIME_LOGIN:
      return state.set('firstTimeLogin', true);
    case actions.RESET_FIRST_TIME_LOGIN:
      return state.set('firstTimeLogin', false);
    case actions.SET_COGNITO_GROUPS:
      return state.set('groups', action.payload);
    case actions.SET_PROVIDER:
      return state.set('providerId', action.payload);
    case actions.SET_DB_ID:
      return state.set('dbId', action.payload);
    case actions.SET_S3_PHOTO:
      return state.set('s3Photo', action.payload);
    default:
      return state;
  }
}
